export const apiCalculatedAttributesIdAppGroupIdEngagements =
  "/api/calculated_attributes/:id/:app_group_id/engagements";
